import { render, staticRenderFns } from "./XLSX.vue?vue&type=template&id=08025ced"
import script from "./XLSX.vue?vue&type=script&lang=js"
export * from "./XLSX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports